<script>
    export let tagName;
</script>

<span class="tag" style="">
    { tagName }
</span>

<style>
    .tag {
        color: #2a7e19;
        font-size: 1rem;
        padding: 0.125rem 0.25rem;
    }
</style>